import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import SubscriptionTipsBox from './SubscriptionTipsBox';

export const getSubscriptionTipsWidgetConfig = ({
  t,
  dispatch,
}): WidgetConfig => ({
  viewComponent: SubscriptionTipsBox,
});
